
export default {
    namespaced: true,
    state: {
        currentPage: 1,
        perPage: 20,
        totalRows: 0,
        tasks: [],
    },
    getters: {
        TASKS: state => {
            return state.tasks;
        },
        CURRENT_PAGE: state => {
            return state.currentPage;
        },
        TOTAL_ROWS: state => {
            return state.totalRows;
        },
        PER_PAGE: state => {
            return state.perPage;
        },
        AMOUNT_PAGE: (state) => {
            return Math.ceil(state.totalRows/state.perPage);
        }
    },
    mutations: {
        TASKS: (state, payload) => {
            return state.tasks = payload;
        },
        CURRENT_PAGE: (state, payload) => {
            return state.currentPage = payload;
        },
        TOTAL_ROWS: (state, payload) => {
            return state.totalRows = payload;
        },
        PER_PAGE: (state, payload) => {
            return state.perPage = payload;
        },
    },
    actions: {
        GET_DATA: async ({state}, payload) => {
            payload.th.showOverlay ++;
            // set null for rewrite vue component
            state.currentBrand = null
            payload.th.$forceUpdate()
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/suppliers/archive/'+ state.perPage +'/'+ payload.offset,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    state.totalRows = responseData.count
                    state.tasks = responseData.tasks
                },
                getResponse: () => {
                    payload.th.showOverlay --;
                },
            });
        },
        DELETE: async ({state}, payload) => {
            payload.th.showOverlay ++;
            await payload.th.$store.dispatch('SEND_POST', {
                url: '/suppliers/task-delete/'+ payload.taskId,
                th: payload.th,
                showSuccessMessage: true,
                getSuccessResponse: () => {
                    payload.th.updateTaskList()
                },
                getResponse: () => {
                    state.isSendingSAVE = false;
                    payload.th.showOverlay --;
                }
            });
        },
    }
}